import { TabsProps } from "antd"


export interface IFinanceDataRecord {
  id: number
  dateTime: string
  innCount: number
  successCount: number
  fileName: string
}

export interface IFinanceDataRecordCustomer {
  id: number
  customerId: number
  customerName: string
  inn: string
  balanceBefore?: number
  balanceAfter: number
  debit?: number
  credit?: number
  status: FinanceDataRecordCustomerStatus
  statusText: string
}

export interface IFinanceDocument {
  id: number
  documentType: number
  documentTypeText: string
  date: Date
  number: string
  amount: number
  customerId: number
  customerName: string
  customerInn: string
  customerKpp: string
  contract: string
  depotId: number
  depotName: string
  prefix: string
  baseDocument: string
  uid: string
}

export enum FinanceDocumentTypeKeys {
  All = "All",
  Bill = "Bill",
  Bargain = "Bargain",
  PowerOfAttorney = "PowerOfAttorney",
  Invoice = "Invoice",
  AdvanceInvoice = "AdvanceInvoice",
  ReconciliationAct = "ReconciliationAct",
}

export const FinanceDocumentTypeTabs: TabsProps["items"] = [
  {
    key: FinanceDocumentTypeKeys.All,
    label: "Все"
  },
  {
    key: FinanceDocumentTypeKeys.Bargain,
    label: "Торг-12"
  },
  {
    key: FinanceDocumentTypeKeys.PowerOfAttorney,
    label: "Доверенности"
  },
  {
    key: FinanceDocumentTypeKeys.Invoice,
    label: "Счета фактуры"
  },
  {
    key: FinanceDocumentTypeKeys.AdvanceInvoice,
    label: "Авансы"
  },
  {
    key: FinanceDocumentTypeKeys.ReconciliationAct,
    label: "Акты сверки"
  },
  {
    key: FinanceDocumentTypeKeys.Bill,
    label: "Счета на оплату"
  }
]

enum FinanceDataRecordCustomerStatus
{
  Success = 0,
  Error = 1,
  NotFound = 2
}

export const FINANCE_DATA_KEY = "FINANCE_DATA_KEY"
export const FINANCE_DATA_BY_ID_KEY = "FINANCE_DATA_BY_ID_KEY"

export const FINANCE_DATA_FROM_MAILBOX_KEY = "FINANCE_DATA_FROM_MAILBOX_KEY"
export const FINANCE_DATA_FROM_MAILBOX_BY_ID_KEY = "FINANCE_DATA_FROM_MAILBOX_BY_ID_KEY"

export const FINANCE_DOCUMENT_KEY = "FINANCE_DOCUMENT_KEY"
export const FINANCE_DOCUMENT_KEY_CUSTOMER = "FINANCE_DOCUMENT_KEY_CUSTOMER"
export const FINANCE_DOCUMENT_BY_ID_KEY = "FINANCE_DOCUMENT_BY_ID_KEY"